import { CampaignStageType, UserFeatureAccessType } from '@/generated';

export const isFeatureAccessible = (
  user: UserFeatureAccessType,
  required: UserFeatureAccessType,
) => {
  switch (required) {
    case UserFeatureAccessType.Experimental:
      return user === UserFeatureAccessType.Experimental;
    case UserFeatureAccessType.Alpha:
      return [
        UserFeatureAccessType.Alpha,
        UserFeatureAccessType.Experimental,
      ].includes(user);
    case UserFeatureAccessType.Beta:
      return [
        UserFeatureAccessType.Beta,
        UserFeatureAccessType.Alpha,
        UserFeatureAccessType.Experimental,
      ].includes(user);
    case UserFeatureAccessType.Early:
      return [
        UserFeatureAccessType.Early,
        UserFeatureAccessType.Beta,
        UserFeatureAccessType.Alpha,
        UserFeatureAccessType.Experimental,
      ].includes(user);
    case UserFeatureAccessType.Release:
      return true;
  }
};

export const stagesToDisplayOnCalendar = [
  CampaignStageType.Draft,
  CampaignStageType.Syncing,
  CampaignStageType.ReadyToPrepareProofs,
  CampaignStageType.PreparingProofs,
  CampaignStageType.ReadyToExportProofs,
  CampaignStageType.ExportingProofs,
  CampaignStageType.ReadyToProof,
  CampaignStageType.Proofing,
  CampaignStageType.Proofed,
  CampaignStageType.ReadyToPrepare,
  CampaignStageType.Preparing,
  CampaignStageType.Prepared,
  CampaignStageType.ReadyToExport,
  CampaignStageType.Exporting,
  CampaignStageType.ReadyToSchedule,
  CampaignStageType.Scheduling,
  CampaignStageType.Scheduled,
  CampaignStageType.Unscheduling,
  CampaignStageType.Queuing,
  CampaignStageType.ReadyToSend,
  CampaignStageType.Sending,
  CampaignStageType.Suspending,
  CampaignStageType.Suspended,
  CampaignStageType.Resuming,
  CampaignStageType.Completed,
  CampaignStageType.Canceling,
  CampaignStageType.Canceled,
];

export const mapIds = <T extends { id: string }>(items: T[]): string[] => {
  return items.map((item) => item.id);
};

// return key value pairs of all search params.
export const getAllSearchParams = (searchParams: URLSearchParams) => {
  const allParams: Record<string, string> = {};

  for (const [key, value] of searchParams.entries()) {
    allParams[key] = value;
  }

  return allParams;
};
